var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('el-backtop',[_c('i',{staticClass:"el-icon-caret-top"})]),_c('img',{staticClass:"imgs1",attrs:{"src":require("../../assets/images/product/pingcyun.jpg"),"alt":"","srcset":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }